export default __webpack_public_path__ + "static/media/audio3.3cc681a1.vtt";